import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import app from './app';
import cart from './cart';
import data from './data';
import food from './food';
import hotels from './hotels';
import packages from './packages';
import tickets from './tickets';

const cartPersistConfig = {
    key: 'cart',
    storage: storage,
    blacklist: ['loading_cart', 'loading_empty_cart', 'is_toggled'],
};

const appPersistConfig = {
    key: 'app',
    storage: storage,
    blacklist: ['step'],
};

const AppReducers = combineReducers({
    app: persistReducer(appPersistConfig, app),
    data: data,
    packages: packages,
    tickets: tickets,
    food: food,
    hotels: hotels,
    cart: persistReducer(cartPersistConfig, cart),
});

export default AppReducers;
